"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COUPON_APPLIED_DIALOG_DEFAULTS = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _couponOffer = require("../../utils/couponOffer");
var _couponSuccess = _interopRequireDefault(require("./images/coupon-success.gif"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["open", "onClose", "couponCode", "title", "savingsText", "discountValue", "actionText", "savingsSuffix", "colors", "width", "borderRadius", "iconSize", "fontFamily", "iconSrc", "sx"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const COUPON_APPLIED_DIALOG_DEFAULTS = exports.COUPON_APPLIED_DIALOG_DEFAULTS = {
  width: 335,
  borderRadius: 20,
  iconSize: 120,
  actionText: 'Okay',
  savingsSuffix: 'savings with this coupon',
  fontFamily: 'Inter, sans-serif',
  colors: {
    background: '#ffffff',
    title: '#000000',
    savings: '#1eb865',
    savingsBackground: '#ebfff6',
    action: 'var(--primary-button, #714fff)',
    actionText: '#ffffff'
  }
};
const CouponAppliedDialog = _ref => {
  let _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    onClose = _ref.onClose,
    couponCode = _ref.couponCode,
    title = _ref.title,
    savingsText = _ref.savingsText,
    discountValue = _ref.discountValue,
    _ref$actionText = _ref.actionText,
    actionText = _ref$actionText === void 0 ? COUPON_APPLIED_DIALOG_DEFAULTS.actionText : _ref$actionText,
    _ref$savingsSuffix = _ref.savingsSuffix,
    savingsSuffix = _ref$savingsSuffix === void 0 ? COUPON_APPLIED_DIALOG_DEFAULTS.savingsSuffix : _ref$savingsSuffix,
    colorsProp = _ref.colors,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? COUPON_APPLIED_DIALOG_DEFAULTS.width : _ref$width,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? COUPON_APPLIED_DIALOG_DEFAULTS.borderRadius : _ref$borderRadius,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? COUPON_APPLIED_DIALOG_DEFAULTS.iconSize : _ref$iconSize,
    _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === void 0 ? COUPON_APPLIED_DIALOG_DEFAULTS.fontFamily : _ref$fontFamily,
    _ref$iconSrc = _ref.iconSrc,
    iconSrc = _ref$iconSrc === void 0 ? _couponSuccess.default : _ref$iconSrc,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    rest = _objectWithoutProperties(_ref, _excluded);
  const colors = _objectSpread(_objectSpread({}, COUPON_APPLIED_DIALOG_DEFAULTS.colors), colorsProp);
  const resolvedTitle = title !== null && title !== void 0 ? title : couponCode ? "".concat(couponCode, " applied") : null;
  const savings = (0, _couponOffer.getCouponSavingsAmount)(discountValue);
  const resolvedSavings = savingsText !== null && savingsText !== void 0 ? savingsText : savings ? "".concat(savings, " ").concat(savingsSuffix) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Dialog, _objectSpread(_objectSpread({
    open: open,
    onClose: onClose,
    PaperProps: {
      elevation: 0,
      sx: {
        m: 0,
        width: "".concat(width, "px"),
        maxWidth: '90vw',
        borderRadius: "".concat(borderRadius, "px"),
        overflow: 'hidden',
        background: colors.background,
        boxShadow: '0px -4px 10px 0px rgba(0, 0, 0, 0.1)'
      }
    }
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: _objectSpread({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        width: '100%',
        boxSizing: 'border-box',
        px: '20px',
        py: '24px',
        fontFamily
      }, sx),
      children: [iconSrc && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        component: "img",
        src: iconSrc,
        alt: "",
        "aria-hidden": true,
        sx: {
          width: "".concat(iconSize, "px"),
          height: "".concat(iconSize, "px"),
          objectFit: 'cover',
          pointerEvents: 'none'
        }
      }), (resolvedTitle || resolvedSavings) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          width: '100%'
        },
        children: [resolvedTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: 1.2,
            textAlign: 'center',
            wordBreak: 'break-word',
            color: colors.title,
            m: 0
          },
          children: resolvedTitle
        }), resolvedSavings && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            borderRadius: '6px',
            background: colors.savingsBackground
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            sx: {
              fontFamily,
              fontWeight: 600,
              fontSize: '12px',
              lineHeight: '24px',
              letterSpacing: '-0.12px',
              textAlign: 'center',
              color: colors.savings,
              m: 0
            },
            children: resolvedSavings
          })
        })]
      }), actionText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
        disableRipple: true,
        onClick: onClose,
        sx: {
          width: '100%',
          height: '48px',
          borderRadius: '12px',
          background: colors.action
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: 1.4,
            color: colors.actionText,
            m: 0
          },
          children: actionText
        })
      })]
    })
  }));
};
var _default = exports.default = CouponAppliedDialog;